import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as _ from 'lodash';
import { BlowerMode, ControlMode, ISetpointModel, StagingMode } from '../shared/models/models';

// tslint:disable max-line-length
@Component({
    selector: 'dl-setpoint',
    styleUrls: ['./setpoint.component.scss'],
    templateUrl: './setpoint.component.html'
})
export class SetpointComponent {
    public static $name: string = 'clSetpoint';

    public bindings = {
        setpointModel: '=',
        titlePrefix: '@',
        useThemeColors: '<'
    };

    @Input() public setpointModel: ISetpointModel;
    @Input() public titlePrefix: string;
    @Input() public useThemeColors: boolean;

    @Output() public onMouseEnter: EventEmitter<void> = new EventEmitter();
    @Output() public onMouseLeave: EventEmitter<void> = new EventEmitter();

    setpointDescription: string;
    setpointName = null; // maybe delete it latter?
    private colors: boolean;

    public ngOnInit() {
        this.colors = this.getColors();
        this.setup();
    }

    @HostListener('mouseenter')
    public mouseEnter() {
        this.onMouseEnter.emit();
    }

    @HostListener('mouseleave')
    public mouseLeave() {
        this.onMouseLeave.emit();
    }

    public getBlowerOnClass() {
        if (this.isBlowerOnActive()) {
            return 'md-spin';
        }

        return null;
    }

    isCoolingMode(): boolean {
        return this.setpointModel.stagingMode === StagingMode.Cooling;
    }

    isOff(): boolean {
        return this.setpointModel.controlMode === ControlMode.Off;
    }

    isEmergencyHeat(): boolean {
        return this.setpointModel.controlMode === ControlMode.EmergencyHeat;
    }

    isExternal(): boolean {
        return this.setpointModel.controlMode === ControlMode.External;
    }

    isFullControl(): boolean {
        return this.setpointModel.controlMode === ControlMode.FullControl;
    }

    isFullControlHeatOnly(): boolean {
        return this.setpointModel.controlMode === ControlMode.FullControlHeatOnly;
    }

    isFullControlCoolOnly(): boolean {
        return this.setpointModel.controlMode === ControlMode.FullControlCoolOnly;
    }

    isHeatingMode(): boolean {
        return this.setpointModel.stagingMode === StagingMode.Heating;
    }

    isStagingModeOff(): boolean {
        return _.isUndefined(this.setpointModel.stagingMode) || this.setpointModel.stagingMode === StagingMode.Off;
    }

    isBlowerOn(): boolean {
        let controlModeOk: boolean =
            this.isFullControlCoolOnly() || this.isFullControlHeatOnly() || this.isFullControl() || this.isExternal();

        return controlModeOk && this.setpointModel.blowerMode === BlowerMode.On;
    }

    private setup(): void {
        this.getSetpointDescription();
    }

    private getColors(): any {
        if (this.useThemeColors) {
            return {
                background: 'background-hue-3'
            };
        } else {
            return {};
        }
    }

    private getSetpointDescription(): void {
        let builder: string[] = [];

        if (this.isFullControlHeatOnly() || this.isFullControl()) {
            let heating: string = 'Heating';

            if (this.isHeatingMode()) {
                heating += '[On]';
            }

            heating += ': ' + this.setpointModel.heatingTemp + '°';

            builder.push(heating);
        }

        if (this.isFullControlCoolOnly() || this.isFullControl()) {
            let cooling: string = 'Cooling';

            if (this.isCoolingMode()) {
                cooling += '[On]';
            }

            cooling += ': ' + this.setpointModel.coolingTemp + '°';

            builder.push(cooling);
        }

        if (this.isExternal()) {
            builder.push('External');
        }

        if (builder.length > 0) {
            let onAuto: string = this.setpointModel.blowerMode === BlowerMode.On ? 'On' : 'Auto';
            builder.push('Blower: ' + onAuto);
        } else {
            builder.push('Off');
        }

        let description = builder.join(' ');

        this.setpointDescription = _.isUndefined(this.titlePrefix) ? description : this.titlePrefix + ' ' + description;
    }

    private isBlowerOnActive(): boolean {
        return !this.isStagingModeOff() && this.isBlowerOn();
    }
}
